export default "__VITE_ASSET__b60e01eb__"